import { Component } from '@angular/core';
import { LayoutInitService } from 'src/app/RefModules/_metronic/core';
import { LogoNames } from 'src/app/shared/enums/logoNames.enum';

@Component({
    selector: 'app-management-content-main-header',
    templateUrl: './management-content-main-header.component.html',
    styleUrls: ['./management-content-main-header.component.scss'],
    standalone: false
})
export class ManagementContentMainHeaderComponent {
    IA = LogoNames.IA;
    headerMenuSelfDisplay = false;
    headerMenuCSSClasses;
    ulCSSClasses: string;
    rootArrowEnabled: boolean;
    location: Location;
    headerMenuDesktopToggle: string;

    constructor(private layoutInitService: LayoutInitService) {
        this.layoutInitService.init();
    }
}
